import { withHandlers, withProps, branch, renderNothing, compose } from 'recompose'
import { connect } from 'react-redux'
import { showStoreLocatorModalInAppointmentMode } from 'actions/storeLocator'
import { getHasActiveVehicleStatus } from 'selectors'
import TopStoreSelector from './TopStoreSelector'

const mapStateToProps = (state) => ({
  hasActiveVehicle: getHasActiveVehicleStatus(state)
})

const withHandleStoreLocationClick = withHandlers({
  handleStoreLocationClick: ({ showStoreLocatorModalInAppointmentMode }) => (e) => {
    e.stopPropagation()
    showStoreLocatorModalInAppointmentMode()
  }
})

const withVisibilityDetails = withProps(({
  quoteSummary: {
    services = [],
    products = []
  } = {},
  hasActiveVehicle,
  currentStore
}) => ({
  isVisible: !currentStore && hasActiveVehicle && (products.length || services.length)
}))

const withRenderNoting = branch(({ isVisible }) => !isVisible,
  renderNothing
)

export default compose(
  connect(mapStateToProps, { showStoreLocatorModalInAppointmentMode }),
  withHandleStoreLocationClick,
  withVisibilityDetails,
  withRenderNoting
)(TopStoreSelector)
